import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyLira: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconCurrencyLira"><Path d="M8.75 3.75V19.25C8.75 19.8023 9.19772 20.25 9.75 20.25H12C15.1985 20.25 17.8358 17.8474 18.2056 14.7484" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M5 11.5L15 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M5 15.5L15 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCurrencyLira;
